import { Item } from '../../types/order';
import { Address } from '../../types/address';
import { QuoteItem } from '../../types/quote';
import { authToken } from '../authToken';

function buildProducts(
  products: Array<Pick<Item, 'name' | 'weight' | 'width' | 'depth' | 'length'>>
): Array<QuoteItem> {
  return products.map(item => ({
    weight_g: !item.weight ? 1 : item.weight * 1000,
    width_cm: item.width || 1,
    depth_cm: item.depth || 1,
    length_cm: item.length || 1,
  }));
}

export interface QuotePayload {
  merchant_identifier: string;
  quote: {
    authority_to_leave: boolean;
    delivery_date: '';
    delivery_window: '';
    service_level: 'standard';
    dutiable_amount: number;
    return_order: boolean;
    dangerous_goods: boolean;
    customer: {
      address: string;
      suburb: string;
      postcode: string;
      state_code: string;
      country_code: string;
    };
    items: Array<QuoteItem>;
  };
}

export default function getQuotePayload(
  merchantReference: string,
  shippingAddress: Address,
  products: Array<Pick<Item, 'name' | 'weight' | 'width' | 'depth' | 'length'>>
): QuotePayload {
  return {
    merchant_identifier: merchantReference,
    quote: {
      authority_to_leave: true,
      delivery_date: '',
      delivery_window: '',
      service_level: 'standard',
      dutiable_amount: 0,
      return_order: true,
      dangerous_goods: false,
      customer: {
        address: shippingAddress.street![0],
        suburb: shippingAddress.suburb!,
        postcode: shippingAddress.postcode!,
        state_code: shippingAddress.region_code || '',
        country_code: shippingAddress.country_code!,
      },
      items: buildProducts(products),
    },
  };
}

export const getQuotePayloadWithAuth = (
  merchantReference: string,
  shippingAddress: Address,
  products: Array<Pick<Item, 'name' | 'weight' | 'width' | 'depth' | 'length'>>
) => ({
  ...getQuotePayload(merchantReference, shippingAddress, products),
  auth_token: authToken.get(),
});
